import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=321460e4&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"
import style0 from "./Results.vue?vue&type=style&index=0&id=321460e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321460e4",
  null
  
)

export default component.exports